import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./ViewOrderPage.module.css";
import DropDown from "../StatusDropDown/DropDown";
import MessageItem from "./Components/Details/MessageItem";
import MoreDropDown from "./MoreDropDown";
import Details from "./Components/Details/Details";
import Sidebar from "./Components/Sidebar/Sidebar";
import Tasks from "./Components/Tasks/Tasks";
import Forms from "./Components/Forms/Forms";
import Files from "./Components/Files/Files";
import { AnimatePresence } from "framer-motion";
import AssignClientsPopup from "./AssignClientsPopup/AssignClientsPopup";
import AddTaskPopup from "./AddTaskPopup/AddTaskPopup";
import DeleteConfirmPopup from "../../../../../GlobalComponents/DeleteConfirmPopup/DeleteConfirmPopup";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512">
        <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
    </svg>
);

export default function ViewOrderPage() {
    const navigateTo = useNavigate();
    const [activeTab, setActiveTab] = useState("details");
    const [status, setStatus] = useState("Submitted");

    const [openAssignClientsPopup, setopenAssignClientsPopup] = useState(false);
    const handleOpenAssignClientsPopup = () => {
        setopenAssignClientsPopup(true);
    }

    const handleCloseAssignClientsPopup = () => {
        setopenAssignClientsPopup(false);
    }

    const [openAddTaskPopup, setopenAddTaskPopup] = useState(false);
    const handleOpenAddTaskPopup = () => {
        setopenAddTaskPopup(true);
    }

    const handleCloseAddTaskPopup = () => {
        setopenAddTaskPopup(false);
    }

    const [openConfirmPopup, setopenConfirmPopup] = useState(false);
    const handleCloseConfirmPopup = () => {
        setopenConfirmPopup(false);
    }
    const handleOpenConfirmPopup = () => {
        setopenConfirmPopup(true);
    }
    const handleConfirmSubmit = () => {
        handleCloseConfirmPopup();
    }

    return (
        <>
            <div className={Classes.container}>
                <div className={Classes.header}>
                    <button onClick={() => navigateTo("/orders")} className={Classes.backButton}>
                        <LeftArrow height='12px' fill='#969696' />
                        <h5>Orders</h5>
                    </button>
                    <MoreDropDown handleOpenAssignClientsPopup={handleOpenAssignClientsPopup}
                        handleOpenAddTaskPopup={handleOpenAddTaskPopup} handleOpenConfirmPopup={handleOpenConfirmPopup}
                    />
                </div>

                <div className={Classes.hero} >
                    <div className={Classes.heroLeft}>
                        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
                    </div>
                    <div className={Classes.heroRight} >
                        <div className="flexAlign10 mb-30" style={{ padding: '0 25px' }} >
                            <h3>Problem with the analytics</h3>
                            <DropDown selectedValue={status} options={["Submitted", "Working"]} onChange={setStatus} />
                        </div>

                        {activeTab === "details" && <Details />}
                        {activeTab === "tasks" && <Tasks />}
                        {activeTab === "forms" && <Forms />}
                        {activeTab === "files" && <Files />}

                    </div>
                </div>

            </div>

            <AnimatePresence>
                {openAssignClientsPopup && <AssignClientsPopup handleClose={handleCloseAssignClientsPopup} />}
            </AnimatePresence>

            <AnimatePresence>
                {openAddTaskPopup && <AddTaskPopup handleClose={handleCloseAddTaskPopup} />}
            </AnimatePresence>

            <AnimatePresence>
                {openConfirmPopup && <DeleteConfirmPopup handleClose={handleCloseConfirmPopup} handleSubmit={handleConfirmSubmit} />}
            </AnimatePresence>
        </>
    );
}